import styled from 'styled-components';

export const Button = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 2.4rem;
  color: ${({ inFavorites }) => (inFavorites ? '#D64545' : '#fff')};
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    color: #d64545;
  }
`;

// export const Button = styled.button`
//   width: 100px;
//   margin-top: 1rem;
//   padding: 0.5rem 0.5rem;
//   text-align: center;
//   border: 1px solid;
//   border-color: ${({ status }) =>
//     status === 'Saved'
//       ? 'var(--l-grey)'
//       : status === 'Remove'
//       ? '#F35627'
//       : 'var(--d-grey)'};
//   font-size: 1.4rem;
//   border-radius: 6px;
//   color: ${({ status }) =>
//     status === 'Saved'
//       ? 'var(--l-grey)'
//       : status === 'Remove'
//       ? '#F35627'
//       : 'var(--d-grey)'};
//   cursor: pointer;
//   &:hover {
//     ${({ status }) =>
//       status === 'Save' && 'border-color: #57AE5B; color: #57AE5b'}
// `;
